import { motion } from "framer-motion";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";

export const FAQS = [
  {
    q: "How do I get the 10% off?",
    a: "Just tap any product card above. Each link opens the official store with the discount code already attached — you'll see the 10% come off automatically at checkout. No coupon hunting required.",
  },
  {
    q: "Are these discounts legit?",
    a: "Yes. Every link carries a live, working referral code for the official brand store. You buy directly from Dubby, THCA Small Buds, or Bomb — not a third party — so you get authentic products and real savings.",
  },
  {
    q: "What is THCA flower?",
    a: "THCA is the raw, non-active form of THC found in the cannabis plant. When heated or burned (smoked, vaped, or dabbed), THCA converts into THC — the compound responsible for the psychoactive effect. THCA Small Buds are hand-trimmed, lab-tested flower that delivers top-shelf quality at a lower price point. Always check your local laws before purchasing.",
  },
  {
    q: "What's a Bomb electric dab rig (e-rig)?",
    a: "The Bomb Erig Aerix is a portable electric dab rig with a ceramic coil, adjustable temperature, and no torch required — instant heat and clean flavor in a compact, rechargeable device.",
  },
  {
    q: "Is the code stackable or one-time use?",
    a: "The 10% referral discount applies each time you shop through these links. Bookmark this page or share it with friends so the savings are always one tap away.",
  },
  {
    q: "Do you sell the products directly?",
    a: "No — this is a curated promo page. When you tap a card you're sent straight to the brand's own website to complete your purchase safely and securely.",
  },
];

const reveal = {
  hidden: { opacity: 0, y: 24 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, delay: i * 0.06, ease: [0.16, 1, 0.3, 1] },
  }),
};

export const FAQ = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative border-t border-white/10 px-6 py-24 md:px-10 md:py-32"
    >
      <div className="mx-auto grid max-w-7xl gap-12 md:grid-cols-[0.8fr_1.2fr] md:gap-20">
        <div>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="mb-6 font-mono-accent text-xs uppercase tracking-[0.25em] text-zinc-500"
          >
            / Questions
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            className="font-display text-4xl font-extrabold tracking-tighter text-white md:text-6xl"
          >
            Frequently
            <br />
            <span className="text-[#ccff00]">asked.</span>
          </motion.h2>
        </div>

        <Accordion
          type="single"
          collapsible
          defaultValue="item-0"
          className="w-full"
        >
          {FAQS.map((item, i) => (
            <motion.div
              key={i}
              custom={i}
              variants={reveal}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-40px" }}
            >
              <AccordionItem
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-white/10"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="py-6 font-display text-lg font-bold tracking-tight text-white no-underline hover:no-underline hover:text-[#ccff00] [&>svg]:h-5 [&>svg]:w-5 [&>svg]:text-[#ccff00] md:text-xl"
                >
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-base leading-relaxed text-zinc-400">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            </motion.div>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
